import { render } from "./category.vue?vue&type=template&id=e9aa8c66&scoped=true&ts=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"

import "./category.vue?vue&type=style&index=0&id=e9aa8c66&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9aa8c66"]])

export default __exports__